import React from 'react'
import {User} from 'data/types'
import moment from 'moment'
import i18n from 'i18n'
import {Row} from './Display'
import UserAvatar from './UserAvatar'

type CommentChatHeaderProps = {
  user: User
  i18nPlaceholder: string
  createdAt: string
}

export default function CommentChatHeader(props: CommentChatHeaderProps) {
  return (
    <Row className="px-8 items-center">
      <UserAvatar user={props.user} />
      <div className="text-sm font-semibold ml-2">
        {i18n.t(props.i18nPlaceholder, {firstName: props.user.firstName, lastName: props.user.lastName})}
      </div>
      <span className="text-sm text-itx-gray-dark ml-2">{moment(props.createdAt).startOf('minutes').fromNow()} </span>
    </Row>
  )
}
